import { Avatar, type AvatarProps } from '@mantine/core'

import { useUserPhoto } from 'src/features/people/hooks/useUserPhoto'
import { getAvatarColor, getInitials } from 'src/features/people/utils'

type Props = AvatarProps & {
  scimId?: string | null
  photoUrl?: string | null
  firstName?: string | null
  lastName?: string | null
  name?: string
}

export const UserAvatar = ({
  scimId,
  photoUrl,
  firstName,
  lastName,
  name,
  ...rest
}: Props) => {
  const src = useUserPhoto(scimId, !!photoUrl)
  const initials = getInitials(firstName ?? '', lastName ?? '')

  return (
    <Avatar src={src} color={getAvatarColor(name ?? '')} {...rest}>
      {initials}
    </Avatar>
  )
}
